/* unplugin-vue-components disabled */import { render } from "./SvgIconCalendar.vue?vue&type=template&id=1d392405"
import script from "./SvgIconCalendar.vue?vue&type=script&lang=js"
export * from "./SvgIconCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__